import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, RequestOptions, Response, ResponseContentType, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Parametrage} from './parametrage.model';
import {CONSTANTS} from '../../cadens.constants';

@Injectable()
export class ParametrageService {

    private resourceUrl = 'api/parametrages';
    private resourceUrlWithCode = 'api/parametrages/withCode';
    private resourceParametragePageAllUrl = 'api/public/getParametragePageAll';
    private ResourceParametragePageEspaceConnexion = 'api/public/getParametragePageEspaceConnexion';
    private resourceParametragePageFaqUrl = 'api/public/getParametragePageFaq';
    private parametrageFileUrl = 'api/parametragesFile';
    private parametrageSuppressFileUrl = 'api/parametragesSuppressFile';
    private parametrageFileNameUrl = 'api/parametragesFileName';

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

    constructor(private http: Http) { }

    create(parametrage: Parametrage): Observable<Parametrage> {
        let copy: Parametrage = Object.assign({}, parametrage);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(parametrages: Parametrage[]): Observable<Parametrage[]> {
        let copy: Parametrage[] = parametrages.splice(0);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Parametrage> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return res.json();
        });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.rubrique) {
            params.set('rubrique', req.rubrique.toUpperCase());
        } else if (req.page) {
            params.set('page', req.page.toUpperCase());
        }
        return this.http.get(this.resourceUrl, { search: params });
    }

    queryAvecCode(rubrique: String, page: String, code: String): Observable<Response> {
        let params = new URLSearchParams();
        params.set('rubrique', rubrique.toUpperCase());
        params.set('page', page.toUpperCase());
        params.set('code', code.toUpperCase());
        return this.http.get(this.resourceUrlWithCode, { search: params });
    }


    queryPageEspaceConnexion(): Observable<Response> {
        return this.http.get(this.ResourceParametragePageEspaceConnexion);
    }

    queryPageAll(): Observable<Response> {
        return this.http.get(this.resourceParametragePageAllUrl);
    }

    queryPageFaq(): Observable<Response> {
        return this.http.get(this.resourceParametragePageFaqUrl);
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    public parametresArrayToObject(params: Parametrage[]) {
        let object = {};
        params.forEach(param => {
            object[param.code + ''] = param;
        });
        return object;
    }

    public queryVDipAnnee(): Observable<Response>  {
        return this.queryAvecCode( CONSTANTS.GENERAL, CONSTANTS.ALL, CONSTANTS.VDIP_ANNEE) ;
    }

    public queryURLenSavoirPlusDiplome(): Observable<Response>  {
        return this.queryAvecCode( CONSTANTS.GENERAL, CONSTANTS.PIECES, CONSTANTS.URL_EN_SAVOIR_PLUS_DIPLOME) ;
    }

    public getFile(parametreCategorie: string, parametre: string): Observable<Blob> {
        let params = new URLSearchParams();
        params.set('parametreCategorie', parametreCategorie);
        params.set('parametre', parametre);
        let requestOption = new RequestOptions({
            responseType: ResponseContentType.Blob as ResponseContentType.Json
        });
        return this.http.get(this.parametrageFileUrl,
            {search: params, responseType: ResponseContentType.Blob}).map(
            (res) => {
                return new Blob([res.blob()], {type: 'application/pdf'});
            });

    }

    getFileName(parametreCategorie: string, parametre: string): Observable<Response> {
        let params = new URLSearchParams();
        params.set('parametreCategorie', parametreCategorie);
        params.set('parametre', parametre);
        return this.http.get(this.parametrageFileNameUrl, {search: params});
    }

    suppressFile(parametreCategorie: string, parametre: string): Observable<Response> {
        let params = new URLSearchParams();
        params.set('parametreCategorie', parametreCategorie);
        params.set('parametre', parametre);
        let options = new RequestOptions({search: params});
        return this.http.delete(this.parametrageFileUrl, options);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/parametrage/parametrage.service.ts